import React from 'react';
import { SearchIcon, RefreshCwIcon, RotateCcwIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ActionBarProps {
  selectedCount: number;
  onRestoreClick: () => void;
  onRefresh: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  isRefreshing: boolean;
}
export function ActionBar({
  selectedCount,
  onRestoreClick,
  onRefresh,
  searchQuery,
  onSearchChange,
  isRefreshing
}: ActionBarProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between px-5 py-3 border-b border-slate-200 bg-slate-50/50 gap-3" data-id="element-3">
      <div className="flex items-center gap-3" data-id="element-4">
        <button onClick={onRestoreClick} disabled={selectedCount === 0} className={`
            inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-all
            ${selectedCount > 0 ? 'bg-cyan-600 text-white hover:bg-cyan-700 shadow-sm shadow-cyan-600/20 active:shadow-none' : 'bg-slate-100 text-slate-400 border border-slate-200 cursor-not-allowed'}
          `} data-id="element-5">
          <RotateCcwIcon className="w-3.5 h-3.5" data-id="element-6" />
          Restore Selected
        </button>

        <AnimatePresence data-id="element-7">
          {selectedCount > 0 && <motion.span initial={{
          opacity: 0,
          scale: 0.9,
          x: -4
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          x: -4
        }} transition={{
          duration: 0.15
        }} className="text-sm font-medium text-cyan-700 bg-cyan-50 px-2.5 py-1 rounded-md border border-cyan-100" data-id="element-8">
              {selectedCount} {selectedCount === 1 ? 'case' : 'cases'} selected
            </motion.span>}
        </AnimatePresence>
      </div>

      <div className="flex items-center gap-2" data-id="element-9">
        <div className="relative" data-id="element-10">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-11">
            <SearchIcon className="h-3.5 w-3.5 text-slate-400" data-id="element-12" />
          </div>
          <input type="text" placeholder="Search by subject or description…" value={searchQuery} onChange={e => onSearchChange(e.target.value)} className="block w-full sm:w-60 pl-9 pr-3 py-2 border border-slate-200 rounded-lg text-sm bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-500/40 focus:border-cyan-500 transition-all" data-id="element-13" />
        </div>

        <button onClick={onRefresh} disabled={isRefreshing} className="p-2 text-slate-400 hover:text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500/40" aria-label="Refresh list" data-id="element-14">
          <RefreshCwIcon className={`w-3.5 h-3.5 ${isRefreshing ? 'animate-spin text-cyan-600' : ''}`} data-id="element-15" />
        </button>
      </div>
    </div>;
}